import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import {
  StyledStickerProps,
  TStickerSize,
  TStickerType,
} from './Sticker.types';

const infoCSSVars = css`
  --l-color: var(--color-interface-secondary-normal);
  --l-background: var(--color-brand-blue2-lightest);
`;

const warningCSSVars = css`
  --l-color: var(--color-feedback-warning-darkest);
  --l-background: var(--color-feedback-warning-lightest);
`;

const errorCSSVars = css`
  --l-color: var(--color-feedback-error-darkest);
  --l-background: var(--color-feedback-error-lightest);
`;

const successCSSVars = css`
  --l-color: var(--color-feedback-success-darkest);
  --l-background: var(--color-feedback-success-lightest);
`;

const shareCSSVars = css`
  --l-color: var(--color-interface-secondary-normal);
  --l-background: var(--color-feedback-information-lightest);
`;

const sizeMediumCSSVars = css`
  --l-padding: calc(var(--spacing-xxs) * 2) var(--spacing-s);
  --l-font-weight: 500;
  --l-font-size: 12px;
`;

const sizeSmallCSSVars = css`
  --l-padding: 0 calc(var(--spacing-xxs) * 2);
  --l-font-weight: 400;
  --l-font-size: 10px;
`;

const sizeCssVars: Record<TStickerSize, FlattenSimpleInterpolation> = {
  medium: sizeMediumCSSVars,
  small: sizeSmallCSSVars,
};

const typeCssVars: Record<TStickerType, FlattenSimpleInterpolation> = {
  info: infoCSSVars,
  warning: warningCSSVars,
  error: errorCSSVars,
  success: successCSSVars,
  share: shareCSSVars,
};

export const StyledSticker = styled.span<StyledStickerProps>`
  ${(p) => typeCssVars[p.type as TStickerType]}
  ${(p) => sizeCssVars[p.size as TStickerSize]}

  cursor: default;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: var(--l-padding);
  border-radius: var(--radius-4);
  color: var(--l-color);
  background: var(--l-background);
  width: fit-content;
  white-space: nowrap;

  font-weight: var(--l-font-weight);
  font-size: var(--l-font-size);
  line-height: 16px;
`;
